import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule, Routes} from '@angular/router';

import {AuthGuard} from './guard/shared/auth.guard';
import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';
import {AuthLayoutComponent} from './layouts/auth-layout/auth-layout.component';
import {LoginComponent} from './pages/conta/login/login.component';
import {ResetarSenhaComponent} from './pages/conta/resetar-senha/resetar-senha.component';
import {AreaClienteComponent} from './pages/modulos/portal/components/area-cliente/area-cliente.component';
import {GeiaPortalComponent} from './pages/modulos/portal/components/geia-portal/geia-portal.component';
import {HomeComponent} from './pages/modulos/Site/components/home/home.component';
import {NotFoundComponent} from './pages/not-found/not-found.component';

import {AuthPropostaExternaGuard} from './guard/shared/auth-proposta-externa.guard';
import {PropostaExternaLayoutComponent} from './layouts/proposta-externa/proposta-externa-layout.component';
import {CotacaoVisualizarComponent} from './pages/area-logada/cotacao/cotacao-visualizar/cotacao-visualizar.component';
import {DocumentoVisualizarComponent} from './pages/area-logada/proposta/documento-visualizar/documento-visualizar.component';
import {LandingPageSegurosComponent} from './pages/modulos/landing-page/landing-page-seguros/landing-page-seguros.component';
import {BannerSimuladorPrecoComponent} from './pages/modulos/portal/components/banner-simulador-preco/banner-simulador-preco.component';
import {SegurosComponent} from './pages/modulos/portal/components/seguros/seguros.component';
import {SimuladorPrecoComponent} from './pages/modulos/portal/components/simulador-preco/simulador-preco.component';
import {PropostaAssociadoEntidadeComponent} from './pages/modulos/proposta-externa/proposta-associado-entidade/proposta-associado-entidade/proposta-associado-entidade.component';
import {QuizEstiloDeVidaComponent} from './pages/modulos/quiz-estilo-de-vida/quiz-estilo-de-vida.component';
import {GrandesEPmeComponent} from './pages/modulos/Site/components/empresas/grandes-e-pme/grandes-e-pme.component';
import {PmeComponent} from './pages/modulos/Site/components/empresas/pme/pme.component';
import {TesteDeployComponent} from './pages/teste-deploy/teste-deploy.component';
import { QuizTesteVitalidadeComponent } from './pages/Modules/quiz-teste-vitalidade/quiz-teste-vitalidade.component';

const routes: Routes = [
  {
    path: 'teste-deploy',
    component: TesteDeployComponent,
  },
  {
    path: 'versao',
    component: TesteDeployComponent,
  },
  {
    path: 'home',
    redirectTo: 'home',
    pathMatch: 'full',
  },

  {path: 'about-geia', component: HomeComponent},
  {path: 'para-voce', component: HomeComponent},
  {path: 'pme', component: GrandesEPmeComponent},
  {path: 'grande-empresa', component: GrandesEPmeComponent},
  {path: 'geia-empresa', component: PmeComponent},
  {
    path: 'portal/cotacao/:id',
    component: SimuladorPrecoComponent,
  },
  //tipo Plano= odonto ou odoonto
  {path: 'portal/cotacao/:tipoPlano/:id', component: SimuladorPrecoComponent},

  {
    path: 'lp/fesp/adesao',
    component: BannerSimuladorPrecoComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'indicageia',
    component: HomeComponent,
  },
  {
    path: '',
    component: HomeComponent,
  },

  {
    path: 'resetar-senha',
    component: ResetarSenhaComponent,
  },
  {
    path: 'cliente',
    component: AreaClienteComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'portal',
    component: GeiaPortalComponent,
  },
  {
    path: 'seguro',
    component: SegurosComponent,
  },
  {
    path: 'portal/saude',
    component: GeiaPortalComponent,
  },
  {
    path: 'portal/seguro',
    component: GeiaPortalComponent,
  },

  {
    path: 'portal/odonto',
    component: GeiaPortalComponent,
  },
  {
    path: 'landing-page/seguros',
    component: LandingPageSegurosComponent,
  },
  {
    path: 'pme',
    component: GrandesEPmeComponent,
  },
  {
    path: 'grande-empresa',
    component: GrandesEPmeComponent,
  },

  //DESENV START
  {
    //quando logado =>//proposta/colaborador/9FC24D1B-A29A-47AE-5C8B-08DD163FB723 que é o editar da proposta
    path: 'desenv-proposta/proposta/colaborador/:idProposta',
    component: PropostaAssociadoEntidadeComponent,
  },
  {
    //para logar =>//detalhes/proposta/autenticacao/9FC24D1B-A29A-47AE-5C8B-08DD163FB723
    //quando logado =>//detalhes/proposta/9FC24D1B-A29A-47AE-5C8B-08DD163FB723
    path: 'desenv-proposta/proposta/beneficiario/:idProposta',
    component: PropostaAssociadoEntidadeComponent,
  },

  // DESENV FIM
  {
    path: 'proposta/colaborador/:idProposta', //levar para o component de PropostaExternaLayoutComponent
    component: PropostaAssociadoEntidadeComponent,
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
      },
    ],

    //responsavel por gerenciar rotas de autenticacao
    canActivate: [AuthGuard],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/layouts/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule),
      },
    ],
  },
  {
    path: 'detalhes',
    component: PropostaExternaLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('src/app/layouts/proposta-externa/proposta-externa-layout.module').then(
            m => m.PropostaExternaLayoutModule,
          ),
      },
    ],
  },
  //cotacao visualizar - link da proposta (pdf)
  {
    path: 'cotacao/visualizar/:idCotacao',
    component: CotacaoVisualizarComponent,
  },
  {
    path: 'cotacao/visualizar/:idCotacao/:tipo',
    component: CotacaoVisualizarComponent,
  },
  // Rota para visualização de documentos do colaborador
  {
    path: 'proposta/documento/colaborador/visualizar/:idProposta',
    component: DocumentoVisualizarComponent,
    canActivate: [AuthGuard],
    data: {tipoAcesso: 'colaborador'},
  },
  {
    path: 'proposta/documento/beneficiario/visualizar/:idProposta',
    component: DocumentoVisualizarComponent,
    data: {tipoAcesso: 'beneficiario'},
    canActivate: [AuthPropostaExternaGuard],
    runGuardsAndResolvers: 'paramsChange',
  },
  {
    path: 'quiz-estilo-de-vida',
    component: QuizEstiloDeVidaComponent,
  },
  {
    path: 'quiz-teste-vitalidade',
    component: QuizTesteVitalidadeComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [],
})
export class AppRoutingModule {}
